import { useSidewall } from '../../../../../hooks/state/useSidewall'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
import { RoundedBox } from '@react-three/drei'

export const MarqueeVerticalBox = (): JSX.Element => {
  const { verticalMarqueeAttr, verticalMarqueeMetalColor } = useSidewall()

  return (
    <group
      dispose={null}
      castShadow
      receiveShadow
      position={[0, (-verticalMarqueeAttr.height * 0.2) / 2, 0]}
    >
      <mesh>
        <RoundedBox
          args={[
            verticalMarqueeAttr.depth,
            verticalMarqueeAttr.height * 0.8,
            verticalMarqueeAttr.width +
              (verticalMarqueeAttr.position === 'in' ? 0 : 0.02),
          ]}
          radius={0.0005}
          smoothness={0.5}
          castShadow={true}
          matrixWorldAutoUpdate={undefined}
          getObjectsByProperty={undefined}
          getVertexPosition={undefined}
        >
          <CachedMeshPhysicalMaterial
            color={verticalMarqueeMetalColor}
            metalness={0.2}
          />
        </RoundedBox>
        <RoundedBox
          args={[
            verticalMarqueeAttr.depth,
            verticalMarqueeAttr.height * 0.2,
            verticalMarqueeAttr.width +
              (verticalMarqueeAttr.position === 'in' ? 0 : 0.02),
          ]}
          position={[0, verticalMarqueeAttr.height / 2, 0]}
          radius={0.0005}
          smoothness={0.5}
          castShadow={true}
          matrixWorldAutoUpdate={undefined}
          getObjectsByProperty={undefined}
          getVertexPosition={undefined}
        >
          <CachedMeshPhysicalMaterial
            color={verticalMarqueeMetalColor}
            metalness={0.2}
          />
        </RoundedBox>
      </mesh>
    </group>
  )
}
